import AuthHeader from "features/authHeader/AuthHeader";
import PendingApprovalComponent from "features/pendingApprovalComponent";
import FullscreenContainer from "features/containers/FullscreenContainer";

const PendingApproval: React.FC = () => {
  return (
    <FullscreenContainer sx={{ bgcolor: "primary.main" }}>
      <AuthHeader />
      <PendingApprovalComponent />
    </FullscreenContainer>
  );
};

export default PendingApproval;
